// Groups a course library by category for the welcome wizard's course picker
// (Muhammad, 5 Oct 2026: step 3 shows categories, not every course at once).
//
// courses:    [{ id, name, categoryId }] - categoryId is the hashed id GET
//             /courses-data returns, or null
// categories: [{ id, name }] - from GET /get_all_course_categories (the
//             template company's set plus the company's own)
//
// Returns [{ id, name, courses }], largest first, with any course whose
// category is missing or unknown in a final "Other courses" group.

export const OTHER_COURSES = { id: "other", name: "Other courses" };

export function groupCoursesByCategory(courses, categories) {
  const names = {};
  (categories || []).forEach(function(category) {
    if (category && category.id) names[category.id] = category.name;
  });

  const groups = {};
  (courses || []).forEach(function(course) {
    const known = course.categoryId && names[course.categoryId];
    const id = known ? course.categoryId : OTHER_COURSES.id;
    if (!groups[id]) {
      groups[id] = { id: id, name: known ? names[id] : OTHER_COURSES.name, courses: [] };
    }
    groups[id].courses.push(course);
  });

  return Object.keys(groups)
    .map(function(id) {
      return groups[id];
    })
    .sort(function(a, b) {
      if (a.id === OTHER_COURSES.id) return 1;
      if (b.id === OTHER_COURSES.id) return -1;
      return b.courses.length - a.courses.length || a.name.localeCompare(b.name);
    });
}
